export default "__VITE_ASSET__CmBt1eVj__"